/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { TranslatedSentence } from './translated-sentence';

/**
 *
 * @export
 * @interface AddTranslation
 */
export interface AddTranslation {
  /**
   *
   * @type {string}
   * @memberof AddTranslation
   */
  message: AddTranslationMessageEnum;
  /**
   * Speechmatics JSON output format version number.
   * @type {string}
   * @memberof AddTranslation
   */
  format?: string;
  /**
   *
   * @type {string}
   * @memberof AddTranslation
   */
  language: string;
  /**
   *
   * @type {Array<TranslatedSentence>}
   * @memberof AddTranslation
   */
  results: Array<TranslatedSentence>;
}

export const AddTranslationMessageEnum = {
  AddTranslation: 'AddTranslation',
} as const;

export type AddTranslationMessageEnum =
  (typeof AddTranslationMessageEnum)[keyof typeof AddTranslationMessageEnum];
